import React from 'react';
import PropTypes from 'prop-types';
import { brands } from '../../data/brands';

const BrandList = ({ setSelected, updateBrandSizes }) => (
  <select
    className="c-field-select brandlist__select"
    onChange={e => {
      setSelected(1);
      updateBrandSizes(e.target.options[e.target.selectedIndex]);
    }}
    defaultValue={'DEFAULT'}
  >
    <option disabled value="DEFAULT">
      Select a brand
    </option>
    {brands.map((brand, i) => (
      <option
        key={i}
        value={brand.value}
        data-cup={brand.dataCup || 0}
        data-back={brand.dataBack || 0}
      >
        {brand.value}
      </option>
    ))}
  </select>
);

BrandList.propTypes = {
  setSelected: PropTypes.func,
  updateBrandSizes: PropTypes.func,
};

export default BrandList;
